import { cn } from '../../utils/cn';
import type { EventTaskStatus } from '../../types/eventTeam';

const TASK_STATUS_CONFIG: Record<EventTaskStatus, { label: string; bg: string; text: string; border: string }> = {
  todo: { label: 'To Do', bg: 'bg-slate-500/15', text: 'text-slate-300', border: 'border-slate-500/25' },
  in_progress: { label: 'In Progress', bg: 'bg-amber-500/15', text: 'text-amber-300', border: 'border-amber-500/25' },
  done: { label: 'Done', bg: 'bg-green-500/15', text: 'text-green-300', border: 'border-green-500/25' },
  skipped: { label: 'Skipped', bg: 'bg-glass-200/10', text: 'text-glass-400', border: 'border-glass-200/15' },
};

interface EventTaskStatusBadgeProps {
  status: EventTaskStatus;
  className?: string;
}

export const EventTaskStatusBadge = ({ status, className }: EventTaskStatusBadgeProps) => {
  const config = TASK_STATUS_CONFIG[status] ?? TASK_STATUS_CONFIG.todo;
  return (
    <span
      className={cn(
        'badge badge-dot',
        config.bg,
        config.text,
        config.border,
        className,
      )}
    >
      {config.label}
    </span>
  );
};
